module.exports = __webpack_public_path__ + "img/plant.0d8093a3.svg";